import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

//Mostly text for hours. m is for margin, fw-bold is for bold text

export const About = () => {
  return (
    <header id="about" className="p-4 my-1 rounded-3 aboutImg">
      <div className="container-fluid text-center">
        <h1 className="display-5 fw-bold">About</h1>
        <hr />
        <div className="col-md-8 mx-auto">
          <div className="fw-bold">PJ's Pub Hours:</div>
          <div className="m-2">Monday - Sunday: 3:00 pm - 2:00 am</div>
          <div className="m-2 fw-bold">Kitchen Hours: </div>
          <div className="m-1">
            Open @3:30pm 7 days a week 
          </div>
          <div className="m-1">Close @12am Sunday through Thursday</div>
          <div className="m-1">Close @1am Friday and Saturday</div>
          <div>
            <div className="m-2 fw-bold">Happy Hour:</div>
            <div className="m-1">Industry discount on Mondays: 15% off</div>
            <div>3:00 pm - 7:00 pm Monday – Saturday</div>
            <div>3:00 pm – 2:00 am Sunday</div>
          </div>
          <div>
            <div className="mt-3 mb-1 fw-bold">1717 N Monroe Spokane, WA</div>
          </div>
          <div>
            <div>Phone: 509-919-3788</div>
            <div>Fax: 509-919-3792</div>
            <strong class="h6">
              <a href="mailto:pjspub1717@gmail.com">pjspub1717@gmail.com</a>
            </strong>
          </div>
        </div>
      </div>
    </header>
  );
};
